export const ROLES = {
  MASTER_ADMIN: {value: "masteradmin", name: "Master Admin", ranking: 1},
  ADMIN: {value: "admin", name: "Admin", ranking: 2},
  REGIONAL_ADMIN: {value: "regionalproductadmin", name: "Regional Admin", ranking: 3},
  SALES_ADMIN: {value: "salesadmin", name: "Sales Admin", ranking: 4},
  PRODUCTION: {value: "production", name: "Production", ranking: 5},
  FLEXIBLE: {value: "flexible", name: "Flexible", ranking: 6},
  EXTERNAL: {value: "external", name: "External", ranking: 7}
}

export const ROLE_MAP = {
  masteradmin: 'MASTER_ADMIN',
  masterproductadmin: 'MASTER_ADMIN',
  admin: 'ADMIN',
  regionalproductadmin: 'REGIONAL_ADMIN',
  salesuser: 'SALES_ADMIN',
  salesadmin: 'SALES_ADMIN',
  production: 'PRODUCTION',
  flexible: 'FLEXIBLE',
  external: 'EXTERNAL',
}

export const SELECTIONS_PERMISSIONS = {
  VIEW: {value: "permissionsSelectionsView", name: "view", selected: true},
  EDIT: {value: "permissionsSelectionsEdit", name: "edit", selected: true},
  ADD: {value: "permissionsSelectionsAdd", name: "add", selected: true},
  REQUEST_IMAGES: {value: "permissionsSelectionsImages", name: "Request images", selected: true},
  SHARED_LINK: {value: "permissionsSelectionsLink", name: "Generate shared link", selected: true},
  EXCEL: {value: "permissionsSelectionsExcel", name: "Generate excel", selected: true},
  PDF: {value: "permissionsSelectionsPdf", name: "Generate pdf", selected: true},
}

export const USERS_PERMISSIONS = {
  VIEW: {value: "permissionsUsersView", name: "view", selected: true},
  EDIT: {value: "permissionsUsersEdit", name: "edit", selected: true},
  DEACTIVATE: {value: "permissionsUsersDeactivate", name: "deactivate", selected: true},
  DELETE: {value: "permissionsUsersDelete", name: "delete", selected: true},
  ADD: {value: "permissionsUsersAdd", name: "add", selected: true},
}

export const TRANSLATIONS_PERMISSIONS = {
  VIEW: {value: "permissionsTranslationsView", name: "view", selected: true},
  EDIT: {value: "permissionsTranslationsEdit", name: "edit", selected: true},
  DELETE: {value: "permissionsTranslationsDelete", name: "delete", selected: true},
  ADD: {value: "permissionsTranslationsAdd", name: "add", selected: true},
}

export default {
  data() {
    return {
      ROLES: ROLES,
      ROLE_MAP: ROLE_MAP,
      SELECTIONS_PERMISSIONS: SELECTIONS_PERMISSIONS,
      USERS_PERMISSIONS: USERS_PERMISSIONS,
      TRANSLATIONS_PERMISSIONS: TRANSLATIONS_PERMISSIONS,
    }
  },

  computed: {
    canNotSeeProducts() {
      return !this.canSeeArticle() && !this.canSeeDecor() && !this.canSeePackaging();
    },

    canSeeSelections() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.SELECTIONS.selected;
      }

      return true;
    },

    canViewSelection() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.SELECTIONS.permissions.find((permission) => {
          return permission.value === 'permissionsSelectionsView'
        }).selected;
      }

      return true
    },

    canEditSelection() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.SELECTIONS.permissions.find((permission) => {
          return permission.value === 'permissionsSelectionsEdit'
        }).selected;
      }

      return true
    },

    activeUser() {
      return this.$dashboardStore.getters.getActiveUser();
    },

    flexibleSelectionsPermissions() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.SELECTIONS.permissions;
      }
      return null;
    },

    flexibleUsersPermissions() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.USERS.permissions;
      }
      return null;
    },

    hasPermissionToEditUsers() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToEditUsers();
    },

    hasPermissionToDeactivateUsers() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToDeactivateUsers();
    },

    hasPermissionToDeleteUsers() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToDeleteUsers();
    },

    hasPermissionToAddUsers() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToAddUsers();
    },
  },

  methods: {
    activeUserHasRole(role) {
      if (!this.activeUser) {
        return false;
      }

      return this.activeUser.permissions.role === role.value;
    },

    activeUserHasRoleInRolesArray(roles) {
      if (!this.activeUser) {
        return false;
      }

      return roles.some((role) => role.value === this.activeUser.permissions.role);
    },

    /* Header */

    canSeeNav() {
      return !this.activeUserHasRole(this.ROLES.PRODUCTION);
    },

    canSeeConfiguration() {
      return this.canSeeUsers() || this.canSeeTranslations();
    },

    canSeeUsers() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToSeeUsers();
    },

    canSeeTranslations() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN])
        || this.flexibleHasPermissionToSeeTranslations();
    },

    /* Packaging */

    canSeePackaging() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.PACKAGES.selected;
      }

      return !this.activeUserHasRole(this.ROLES.PRODUCTION);
    },

    /* Article */

    canSeeArticle() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.ARTICLES.selected;
      }

      return true
    },

    /* Decor */

    canSeeDecor() {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.permissions.DECORS.selected;
      }

      return true
    },

    /* Selections */

    hasPermissionToSeeQuickSelections() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN])
        || this.flexibleHasPermissionToSeeQuickSelections();
    },

    hasPermissionToAddSelections() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN])
        || this.flexibleHasPermissionToAddNewSelections();
    },

    /* Users */

    /* Flexible */

    flexibleHasSelectionPermissionTo(permission) {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE) && this.flexibleSelectionsPermissions !== null) {
        return this.flexibleSelectionsPermissions.find((selectionPermission) => selectionPermission.value === permission.value).selected;
      }
      return false;
    },

    flexibleHasPermissionToSeeQuickSelections() {
      return this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.EDIT) || this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.ADD);
    },

    flexibleHasPermissionToAddNewSelections() {
      return this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.ADD);
    },

    flexibleHasUsersPermissionTo(permission) {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE) && this.flexibleUsersPermissions !== null) {
        return this.flexibleUsersPermissions.find((selectionPermission) => selectionPermission.value === permission.value).selected;
      }

      return false;
    },

    flexibleHasPermissionToSeeUsers() {
      return this.flexibleHasUsersPermissionTo(this.USERS_PERMISSIONS.VIEW);
    },

    flexibleHasPermissionToEditUsers() {
      return this.flexibleHasUsersPermissionTo(this.USERS_PERMISSIONS.EDIT);
    },

    flexibleHasPermissionToDeactivateUsers() {
      return this.flexibleHasUsersPermissionTo(this.USERS_PERMISSIONS.DEACTIVATE);
    },

    flexibleHasPermissionToDeleteUsers() {
      return this.flexibleHasUsersPermissionTo(this.USERS_PERMISSIONS.DELETE);
    },

    flexibleHasPermissionToAddUsers() {
      return this.flexibleHasUsersPermissionTo(this.USERS_PERMISSIONS.ADD) && !this.flexibleIsBasedOn('salesadmin');
    },

    flexibleHasPermissionToSeeTranslations() {
      return this.flexibleHasUsersPermissionTo(this.TRANSLATIONS_PERMISSIONS.VIEW);
    },

    flexibleHasPermissionToEditTranslations() {
      return this.flexibleHasUsersPermissionTo(this.TRANSLATIONS_PERMISSIONS.EDIT);
    },

    flexibleHasPermissionToDeleteTranslations() {
      return this.flexibleHasUsersPermissionTo(this.TRANSLATIONS_PERMISSIONS.DELETE);
    },

    flexibleHasPermissionToAddTranslations() {
      return this.flexibleHasUsersPermissionTo(this.TRANSLATIONS_PERMISSIONS.ADD);
    },

    flexibleIsBasedOn(role) {
      if (this.activeUserHasRole(this.ROLES.FLEXIBLE)) {
        return this.activeUser.permissions.basedOnRole === role;
      }
      return false;
    },

    /* Add User */

    getRolesToAddUser() {
      if (this.activeUserHasRole(this.ROLES.MASTER_ADMIN)) {
        return [this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN, this.ROLES.PRODUCTION, this.ROLES.FLEXIBLE];
      }

      if (this.activeUserHasRole(this.ROLES.ADMIN) || this.flexibleIsBasedOn('admin')) {
        return [this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN, this.ROLES.PRODUCTION, this.ROLES.FLEXIBLE];
      }

      if (this.activeUserHasRole(this.ROLES.REGIONAL_ADMIN) || this.flexibleIsBasedOn('regionalproductadmin')) {
        return [this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN];
      }

      return [];
    },

    getBasedOnRoles() {
      return [this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN, this.ROLES.PRODUCTION];
    },
  }
}
